import { createSelector } from '@reduxjs/toolkit';
import { AssetClassEnum } from 'src/common/enums';

const selectAssetClassEnum = () => AssetClassEnum;

export const selectAllAssetClasses = createSelector([selectAssetClassEnum], (Enum) => Enum.getAll());

export const selectAssetClassById = (id: number | null | undefined) => createSelector([selectAssetClassEnum], (Enum) => Enum.getById(id));

export const selectAssetClassByName = (name: string) => createSelector([selectAssetClassEnum], (Enum) => Enum.getByName(name));

export const selectAssetClassOptions = createSelector([selectAssetClassEnum], (Enum) =>
  Enum.getAll().map((x) => ({
    value: x.id,
    label: x.displayName,
  }))
);
